export const UPDATE_FORMULA =
  'app/EditSessionPage/ReflectionFormula/UPDATE_FORMULA';

export const ADD_FORMULA_CASE =
  'app/EditSessionPage/ReflectionFormula/ADD_FORMULA_CASE';

export const REMOVE_FORMULA_CASE =
  'app/EditSessionPage/ReflectionFormula/REMOVE_FORMULA_CASE';

export const UPDATE_FORMULA_CASE =
  'app/EditSessionPage/ReflectionFormula/UPDATE_FORMULA_CASE';
